// Initialize Cocoon links and other form functionality
document.addEventListener("turbolinks:load", function() {
  console.log("Sales margin form handlers initializing...");
  
  const salesMarginForm = document.querySelector('.sales-margin-form');
  
  if (salesMarginForm) {
    console.log("Found sales margin form on page");
    
    // Initialize Select2 on all current select fields
    initializeSelect2();
    
    // Re-initialize Select2 after Cocoon adds a new association
    document.addEventListener('cocoon:after-insert', function(e) {
      console.log("Cocoon inserted new fields");
      
      // Get the newly inserted element
      const insertedItem = e.detail.insertedItem;
      
      // Initialize Select2 on any select fields in the newly inserted item
      if (insertedItem) {
        const selectElements = insertedItem.querySelectorAll('.select2-field');
        if (selectElements.length > 0) {
          initializeSelect2Fields(selectElements);
        }
      }
    });
    
    // Handle adding new cost types
    document.getElementById('add_cost_type').addEventListener('click', function() {
      const input = document.getElementById('new_cost_type');
      const typeName = input.value.trim();
      
      if (typeName) {
        addCostType(typeName);
        input.value = '';
      }
    });
    
    // Handle adding new margin types
    document.getElementById('add_margin_type').addEventListener('click', function() {
      const input = document.getElementById('new_margin_type');
      const typeName = input.value.trim();
      
      if (typeName) {
        addMarginType(typeName);
        input.value = '';
      }
    });
    
    // Log to console to confirm the script is loaded
    console.log("Sales margin form handlers initialized");
  }
});

function initializeSelect2() {
  const selectElements = document.querySelectorAll('.select2-field');
  initializeSelect2Fields(selectElements);
}

function initializeSelect2Fields(elements) {
  elements.forEach(element => {
    // Destroy Select2 if it's already initialized
    if ($(element).data('select2')) {
      $(element).select2('destroy');
    }
    
    // Initialize Select2
    $(element).select2({
      width: '100%',
      dropdownAutoWidth: true
    });
  });
}

function addCostType(typeName) {
  fetch('/cost_types', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({ cost_type: { name: typeName } })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Add the new option to all cost type select elements
      const selects = document.querySelectorAll('select[name*="[cost_type_id]"]');
      selects.forEach(select => {
        const option = new Option(data.cost_type.name, data.cost_type.id, false, true);
        $(select).append(option).trigger('change');
      });
      
      // Show success message
      showNotification('Cost type added successfully!', 'success');
    } else {
      showNotification(data.errors || 'Failed to add cost type', 'error');
    }
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('An error occurred while adding the cost type', 'error');
  });
}

function addMarginType(typeName) {
  fetch('/margin_types', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({ margin_type: { name: typeName } })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // Add the new option to all margin type select elements
      const selects = document.querySelectorAll('select[name*="[margin_type_id]"]');
      selects.forEach(select => {
        const option = new Option(data.margin_type.name, data.margin_type.id, false, true);
        $(select).append(option).trigger('change');
      });
      
      // Show success message
      showNotification('Margin type added successfully!', 'success');
    } else {
      showNotification(data.errors || 'Failed to add margin type', 'error');
    }
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('An error occurred while adding the margin type', 'error');
  });
}

function showNotification(message, type) {
  const notificationContainer = document.getElementById('notification-container');
  
  if (!notificationContainer) {
    // Create a notification container if it doesn't exist
    const container = document.createElement('div');
    container.id = 'notification-container';
    container.style.position = 'fixed';
    container.style.top = '1rem';
    container.style.right = '1rem';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
    
    showNotification(message, type); // Retry with the container now created
    return;
  }
  
  // Create the notification element
  const notification = document.createElement('div');
  notification.className = `p-4 mb-4 rounded shadow-md ${type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`;
  notification.textContent = message;
  
  // Add the notification to the container
  notificationContainer.appendChild(notification);
  
  // Remove the notification after 5 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transition = 'opacity 0.5s ease';
    
    setTimeout(() => {
      notificationContainer.removeChild(notification);
    }, 500);
  }, 5000);
} 